(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const ui = JSON.parse($('#cf-ui')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || '/';
  const text = (key) => { const value = String(ui[key] || key); return value.replace(/&amp;/g, '&'); };
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (s) => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let previousFocus, timer, product, selectedColour, selectedSize, busy = false;
  const state = (message) => {
    const el = $('#toast');
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(timer);
    timer = setTimeout(() => el.classList.remove('show'), 5500);
  };
  const close = () => {
    $('#overlay').replaceChildren();
    document.body.classList.remove('no-scroll');
    if (previousFocus?.isConnected) previousFocus.focus();
  };
  const open = (title, content, modal = false) => {
    if (!$('#overlay').children.length) previousFocus = document.activeElement;
    $('#overlay').innerHTML = `<div class="dialogbackdrop" data-backdrop><section class="${modal ? 'modal' : 'drawer'}" role="dialog" aria-modal="true" aria-labelledby="dialog-title"><div class="drawerhead"><h2 id="dialog-title">${esc(title)}</h2><button type="button" class="close" data-action="close" aria-label="${esc(text('close'))}">×</button></div>${content}</section></div>`;
    document.body.classList.add('no-scroll');
    $('#overlay .close').focus();
  };
  const openTemplate = (name, modal = false) => {
    const el = $('#cf-' + name + '-template');
    if (el) open(text(name), el.innerHTML, modal);
  };
  async function request(path, options = {}) {
    const response = await fetch(path, {...options, headers: {Accept: 'application/json', ...options.headers}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || text('error'));
    return data;
  }
  async function syncBagCount() {
    try {
      const cart = await request(root + 'cart.js');
      $$('.bagcount').forEach(el => { el.textContent = cart.item_count; });
    } catch (_) { /* The server-rendered count remains available. */ }
  }
  async function bag() {
    if (window.kachingCartApi?.openCart) {
      close();
      window.kachingCartApi.openCart();
      await syncBagCount();
    } else {
      location.href = root + 'cart';
    }
  }
  function productError(message = '') {
    const el = $('#cf-product-error');
    if (el) { el.textContent = message; el.hidden = !message; }
  }
  function initializeProduct() {
    const data = $('#cf-product-data');
    if (!data) return;
    product = JSON.parse(data.textContent);
    const variant = product.variants.find(v => String(v.id) === $('#cf-native-variant').value) || product.variants[0];
    selectedColour = variant.options[0];
    selectedSize = product.selected ? variant.options[1] : '';
    $('.cf-variant-fallback').hidden = true;
    $('.cf-enhanced-options').hidden = false;
    updateVariant(false);
  }
  function updateVariant(changeImage = true) {
    if (!product) return;
    const colour = $$('[data-colour]').find(b => b.dataset.value === selectedColour);
    if (!colour) return;
    $$('[data-colour]').forEach(button => {
      const active = button === colour;
      button.classList.toggle('selected', active);
      button.setAttribute('aria-pressed', String(active));
    });
    $('#colour-name').textContent = colour.dataset.label;
    if (changeImage) {
      const image = $('#main-product-image');
      ++galleryRequest; image.src = colour.dataset.image;
      image.alt = 'Serena ' + colour.dataset.label;
      warmGalleryImage(colour.dataset.image, 'high');
      const thumbs = $$('.gallery-thumbs [data-gallery]');
      thumbs[0].dataset.gallery = colour.dataset.image;
      $('img', thumbs[0]).src = colour.dataset.image;
      thumbs.at(-1).dataset.gallery = colour.dataset.original;
      $('img', thumbs.at(-1)).src = colour.dataset.original;
      thumbs.forEach((button, index) => button.classList.toggle('active', index === 0));
      $('.gallery .smallhint').textContent = image.alt;
    }
    $$('[data-size]').forEach(button => {
      const variant = product.variants.find(v => v.options[0] === selectedColour && v.options[1] === button.dataset.size);
      const active = button.dataset.size === selectedSize;
      button.disabled = !variant?.available;
      button.classList.toggle('selected', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const variant = selectedSize ? product.variants.find(v => v.options[0] === selectedColour && v.options[1] === selectedSize) : product.variants.find(v => v.options[0] === selectedColour && v.available) || product.variants.find(v => v.options[0] === selectedColour);
    const button = $('[data-action="add"]');
    button.disabled = !variant?.available;
    $('[data-add-label]').textContent = variant ? (variant.available ? text('add') : text('sold_out')) : text('unavailable');
    if (variant) {
      $('#cf-native-variant').value = String(variant.id);
      $('[data-current-price]').innerHTML = variant.price_text;
      const sale = variant.compare > variant.price;
      $('[data-compare-price]').hidden = !sale;
      $('[data-saving]').hidden = !sale;
      $('[data-compare-price]').innerHTML = variant.compare_text;
      $('[data-saving]').innerHTML = esc(text('save')) + ' ' + variant.saving_text;
      if (selectedSize) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
    productError();
  }
  async function changeCart(key, quantity) {
    if (busy) return;
    busy = true;
    try {
      await request(root + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key,quantity})});
      if ($('#overlay .cf-cart-content')) await bag(); else location.reload();
    } catch (error) { state(error.message); }
    finally { busy = false; }
  }
  async function privacyApi() {
    if (window.Shopify?.customerPrivacy) return window.Shopify.customerPrivacy;
    return new Promise((resolve,reject) => {
      if (!window.Shopify?.loadFeatures) { reject(new Error(text('error'))); return; }
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => error ? reject(error) : resolve(window.Shopify.customerPrivacy));
    });
  }

  const galleryCache = new Map();
  let galleryRequest = 0;
  function warmGalleryImage(src, priority = 'low') {
    if (!src) return Promise.resolve(null);
    if (galleryCache.has(src)) return galleryCache.get(src);
    const image = new Image(); image.decoding = 'async'; image.fetchPriority = priority;
    const ready = new Promise(resolve => { image.onload = () => image.decode().catch(() => {}).then(() => resolve(image)); image.onerror = () => { galleryCache.delete(src); resolve(null); }; });
    galleryCache.set(src, ready); image.src = src; return ready;
  }
  function warmGalleryNeighbours(button) {
    const buttons = $$('.gallery-thumbs [data-gallery]');
    const index = buttons.findIndex(item => item === button || item.dataset.gallery === button?.dataset.gallery);
    if (index < 0) return;
    [1, -1].forEach(step => warmGalleryImage(buttons[(index + step + buttons.length) % buttons.length]?.dataset.gallery));
  }
  async function showGalleryImage(src, alt, button) {
    const requestId = ++galleryRequest;
    const image = $('#main-product-image'); if (!image || !src) return;
    $$('[data-gallery]').forEach(item => item.classList.toggle('active', item === button || item.dataset.gallery === src));
    warmGalleryNeighbours(button);
    const loaded = await warmGalleryImage(src, 'high');
    if (requestId !== galleryRequest || !loaded) return;
    image.src = src; image.alt = alt || 'Serena';
    const hint = $('.gallery .smallhint'); if (hint) hint.textContent = image.alt;
  }
  function preloadGallery() {
    const buttons = $$('.gallery-thumbs [data-gallery]');
    if (!buttons.length) return;
    warmGalleryImage($('#main-product-image')?.getAttribute('src'), 'high');
    warmGalleryNeighbours(buttons.find(button => button.classList.contains('active')) || buttons[0]);
    const rest = () => buttons.forEach(button => warmGalleryImage(button.dataset.gallery));
    if ('requestIdleCallback' in window) requestIdleCallback(rest, {timeout:1500}); else setTimeout(rest, 500);
    document.addEventListener('pointerover', event => { const button = event.target.closest('[data-gallery]'); if (button) warmGalleryImage(button.dataset.gallery, 'high'); }, {passive:true});
  }
  function initializeGalleryControls() {
    const gallery = $('.gallery-main');
    if (!gallery || $('.cf-gallery-nav', gallery)) return;
    for (const direction of [-1, 1]) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cf-gallery-nav cf-gallery-nav--' + (direction < 0 ? 'prev' : 'next');
      button.dataset.galleryStep = String(direction);
      button.setAttribute('aria-label', direction < 0 ? 'Previous product photo' : 'Next product photo');
      button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (direction < 0 ? 'm14 6-6 6 6 6' : 'm10 6 6 6-6 6') + '"/></svg>';
      gallery.append(button);
    }
  }
  function normalizeArrowIcons() {
    $$('.arrow, [data-photo-direction], [data-tab-step]').forEach(el => {
      if (el.querySelector('svg')) return;
      const left = el.textContent.trim() === '←';
      el.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" class="cf-arrow-icon"><path d="' + (left ? 'M19 12H5m6-6-6 6 6 6' : 'M5 12h14m-6-6 6 6-6 6') + '"/></svg>';
    });
    $$('.rating-read').forEach(el => { el.textContent = el.textContent.replace('↓', '').trim(); });
  }
  initializeGalleryControls();
  normalizeArrowIcons();
  preloadGallery();
  document.addEventListener('submit', async event => {
    if (event.target.getAttribute('id') !== 'cf-product-form') return;
    // Let the Kaching widget submit its selected variants and quantities.
    if ($('kaching-bundle .kaching-bundles__block--loaded', event.target)) return;
    event.preventDefault();
    if (busy) return;
    if (!selectedSize) {
      productError(text('choose_size'));
      $('[data-size]:not(:disabled)')?.focus();
      return;
    }
    const form = event.target;
    const submit = $('[type="submit"]', form);
    busy = true; submit.disabled = true;
    try {
      await request(root + 'cart/add.js', {method:'POST',body:new FormData(form)});
      await bag();
    } catch (error) { productError(error.message); }
    finally { busy = false; submit.disabled = false; }
  });
  document.addEventListener('click', async event => {
    const target = event.target.closest('a,button,[data-backdrop]');
    if (!target) return;
    if (target.closest('#kaching-cart')) return;
    if (target.getAttribute('aria-label') === 'Close cart' || target.textContent.trim().toLowerCase() === 'continue shopping') syncBagCount();
    if (target.hasAttribute('data-backdrop') && target === event.target) { close(); return; }
    if (target.hasAttribute('data-tab-step')) { const tabs = document.getElementById('cf-product-tabs'); tabs?.scrollBy({left:Number(target.dataset.tabStep)*Math.max(150,tabs.clientWidth*.75),behavior:reduced()?'instant':'smooth'}); return; }
    if (target.dataset.scroll) {
      const section = document.getElementById(target.dataset.scroll);
      if (section) { event.preventDefault(); section.scrollIntoView({behavior: reduced() ? 'instant' : 'smooth'}); }
      return;
    }
    if (target.dataset.colour) { selectedColour = target.dataset.value; updateVariant(); return; }
    if (target.dataset.size) { selectedSize = target.dataset.size; updateVariant(false); return; }
    if (target.dataset.quantity) {
      const input = $('#quantity'); input.value = Math.min(99,Math.max(1,(Number(input.value)||1)+Number(target.dataset.quantity))); return;
    }
    if (target.dataset.galleryStep) {
      const thumbs = $$('.gallery-thumbs [data-gallery]');
      const current = Math.max(0, thumbs.findIndex(button => button.classList.contains('active')));
      thumbs[(current + Number(target.dataset.galleryStep) + thumbs.length) % thumbs.length]?.click();
      return;
    }
    if (target.dataset.gallery) {
      showGalleryImage(target.dataset.gallery, $('img',target)?.alt || 'Serena', target); return;
    }
    if (target.dataset.filter) {
      const filter = target.dataset.filter;
      $$('[data-filter]').forEach(button => { const active=button===target;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active)); });
      $$('[data-colour-card]').forEach(card => card.hidden = filter !== 'all' && card.dataset.colourCard !== filter);
      $('#result-count').textContent = text(filter === 'all' ? 'all_colours' : 'one_colour'); return;
    }
    if (target.dataset.photoDirection || target.dataset.reviewDirection) {
      const track = $(target.dataset.photoDirection ? '.source-photo-track' : '#testimonials-track');
      if (!track) return;
      const direction = Number(target.dataset.photoDirection || target.dataset.reviewDirection);
      const end = track.scrollLeft >= track.scrollWidth-track.clientWidth-4;
      const start = track.scrollLeft < 4;
      track.scrollTo({left: direction>0 && end ? 0 : direction<0 && start ? track.scrollWidth : track.scrollLeft+direction*track.clientWidth,behavior:reduced()?'instant':'smooth'}); return;
    }
    if (target.dataset.remove) { event.preventDefault(); await changeCart(target.dataset.remove,0); return; }
    switch (target.dataset.action) {
      case 'close': close(); break;
      case 'bag': event.preventDefault(); await bag(); break;
      case 'product-zoom': {const image=$('#main-product-image');open(text('zoom'),`<img class="zoom-product" src="${esc(image.src)}" alt="${esc(image.alt)}">`,true);break;}
      case 'size': openTemplate('size',true); break;
      case 'menu': openTemplate('menu'); break;
      case 'region': openTemplate('region'); break;
      case 'search': openTemplate('search'); $('#cf-search-input')?.focus(); break;
      case 'cookies':
        try {
          const api = await privacyApi();
          openTemplate('cookies');
          const consent=api.currentVisitorConsent();
          for (const name of ['analytics','marketing','preferences']) $(`#overlay input[name="${name}"]`).checked=consent[name]==='yes';
        } catch { state(text('error')); }
        break;
      case 'save-cookies':
        try {
          const api=await privacyApi();
          const choice=Object.fromEntries(['analytics','marketing','preferences'].map(name=>[name,$(`#overlay input[name="${name}"]`).checked]));
          api.setTrackingConsent(choice,()=>{close();state(text('saved'));});
        } catch { state(text('error')); }
        break;
    }
  });
  document.addEventListener('change',event=>{
    if(event.target.matches('[data-cart-key]')) changeCart(event.target.dataset.cartKey,Math.max(0,Math.min(99,Number(event.target.value)||0)));
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape') close();
    if(event.key==='Tab' && $('#overlay [role="dialog"]')) {
      const nodes=$$('button:not(:disabled),a,input,select,textarea',$('#overlay')).filter(el=>el.getClientRects().length);
      const first=nodes[0],last=nodes.at(-1);
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
  document.addEventListener('shopify:section:load',initializeProduct);
  initializeProduct();
})();


(()=>{
function bind(){document.querySelectorAll('main details:not(.header__drawer):not(.header__search)').forEach(details=>{
if(details.dataset.caMotion)return;const summary=details.querySelector('summary');if(!summary)return;details.dataset.caMotion='1';let animation=null;
summary.addEventListener('click',event=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;event.preventDefault();event.stopImmediatePropagation();const start=details.getBoundingClientRect().height,closing=details.open;if(animation)animation.cancel();details.open=true;details.style.overflow='hidden';const end=closing?summary.getBoundingClientRect().height:details.scrollHeight;
animation=details.animate({height:[start+'px',end+'px']},{duration:300,easing:'cubic-bezier(.22,.61,.36,1)'});animation.onfinish=()=>{details.open=!closing;details.style.overflow='';animation=null};},true);
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});else bind();document.addEventListener('shopify:section:load',bind);
})();
(()=>{
if(location.pathname.startsWith('/apps/'))return;
const attributes={calden_concept:'serena',calden_view:'serena',calden_market:'GB'};
let pending=null,replaying=false;
function save(){if(pending)return pending;pending=fetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})}).then(r=>{if(!r.ok)throw Error('Unable to save checkout details');return r.json()}).finally(()=>pending=null);return pending;}
save().catch(()=>{});
window.addEventListener('click',async event=>{const button=event.target.closest?.('#kaching-cart .kaching-cart__checkout-button,#kaching-cart button[aria-label="Proceed to Checkout"],a[href="/checkout"],button[name="checkout"]');if(!button||replaying)return;event.preventDefault();event.stopImmediatePropagation();try{await save();replaying=true;button.click()}catch(error){alert('We could not prepare checkout. Please try again.')}finally{replaying=false}},true);
})();